import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';

import { AggFunc, BaseComponent, BaseEditFormComponent, TabGridComponent } from 'tms-lib';
import { StockItemHeaderService, TmsWebGridService } from '../../../services';
import { StockItemHeaderReceipt } from '../../../models';

@Component({
  selector: 'app-purchase-order-line-receipts',
  templateUrl: './purchase-order-line-receipts.component.html',
  styleUrl: './purchase-order-line-receipts.component.scss',
})
export class PurchaseOrderLineReceiptsComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormComponent) form: BaseEditFormComponent;
  @ViewChild(TabGridComponent, { static: true }) requirementGrid: TabGridComponent;

  @Input() gridCssClass = 'tab-grid';
  @Input() purchaseOrderLineId: string;

  model$: Observable<StockItemHeaderReceipt[]>;

  columnDefs: ColDef[] = [
    this.gridService.text('stockNo', $localize`Stock Number`, {
      aggFunc: AggFunc.count,
    }),
    this.gridService.text('productKey', $localize`Product`),
    this.gridService.text('batchNo', $localize`Batch Number`),
    this.gridService.text('externalNo', $localize`Supplier Stock Reference`),
    this.gridService.numberFormat('qtyIn', $localize`Quantity Received`, { aggFunc: AggFunc.sum }),
    this.gridService.text('warehouseKey', $localize`Warehouse`),
    this.gridService.text('locationKey', $localize`Location`),
    this.gridService.date('dateCreated', $localize`Date Created`),
  ];

  constructor(
    private stockItemHeaderService: StockItemHeaderService,
    private gridService: TmsWebGridService,
  ) {
    super();
  }

  ngOnInit() {
    this.getModel();
  }

  getModel() {
    this.model$ = this.stockItemHeaderService.getStockReceiptsForPurchaseOrder(this.purchaseOrderLineId);
  }
}
